import submit from "submit-form";
import i18n from "../i18n";

const DailyAccountability = (app) => {
  app
    .post(
      "/daily-accountability/add-template",
      async ({ api, assert, flash, req, res }) => {
        const { body, query } = req;
        const { templateId, fromEdit } = query;
        const method = templateId ? "PUT" : "POST";

        try {
          await api("daily-accountability-template", {
            method: method,
            body: templateId ? { ...body, templateId } : body,
          });

          flash(
            "success",
            templateId ? i18n.t("coaching-portal:dailyAccountabilityActions.successfullyEditedTemplate") : i18n.t("coaching-portal:dailyAccountabilityActions.successfullyAddedTemplate")
          );
          if (fromEdit === "true" || fromEdit === true) {
            res.refreshWith(
              { modal: "", fromEdit: "" },
              { url: "back", hash: "#_" }
            );
          } else {
            res.refreshWith(
              { "modal[type]": "accountability-templates", templateId: "" },
              { url: "back", hash: "#_" }
            );
          }
        } catch (e) {
          flash("error", e.message);
          if (fromEdit === "true" || fromEdit === true) {
            res.refreshWith(
              { modal: "", fromEdit: "" },
              { url: "back", hash: "#_" }
            );
          } else {
            res.refreshWith(
              { "modal[type]": "accountability-templates", templateId: "" },
              { url: "back", hash: "#_" }
            );
          }
        }
      }
    )
    .post(
      "/daily-accountability/remove-item-template",
      async ({ api, assert, flash, req, res }) => {
        const { body, query } = req;
        const { templateId } = query;
        await api("daily-accountability-template", {
          method: "PUT",
          body: { ...body, templateId },
        });

        flash("success", i18n.t("coaching-portal:dailyAccountabilityActions.successfullyEdited"));
        res.backDontScroll();
      }
    )
    .post(
      "/daily-accountability/set-template",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        await api("set-template", {
          method: "POST",
          body,
        });
        flash("success", i18n.t("coaching-portal:dailyAccountabilityActions.successfullyAssigned"));
        res.refreshWith({ modal: "" }, { url: "back", hash: "#_" });
      }
    )
    .post(
      "/daily-accountability/set-default",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        await api("daily-accountability/set-default", {
          method: "POST",
          body,
        });
        flash("success", i18n.t("coaching-portal:dailyAccountabilityActions.successfullyAssignedDefaultTemplate"));
        res.backDontScroll();
      }
    )
    .post(
      "/daily-accountability/remove-default",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        const { templateId, userToRequest } = body;
        await api(
          `daily-accountability/set-default?templateId=${templateId}&userToRequest=${userToRequest}`,
          {
            method: "DELETE",
          }
        );
        flash("success", i18n.t("coaching-portal:dailyAccountabilityActions.successfullyRemovedDefaultTemplate"));
        res.backDontScroll();
      }
    )
    .post(
      "/daily-accountability/remove-template",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        const { templateId, userToRequest } = body;
        // if (confirm("Are you sure you want to delete this template?")) {
        await api(
          `daily-accountability-template?templateId=${templateId}&userToRequest=${userToRequest}`,
          {
            method: "DELETE",
          }
        );
        flash("success", i18n.t("coaching-portal:dailyAccountabilityActions.successfullyRemovedTemplate"));
        res.backDontScroll();
        //  }
      }
    )
    .post(
      "/daily-accountability/update-athlete-accountability/:athleteId",
      async ({
        req: { body, params, query },
        res,
        api,
        flash,
        locals,
        assert,
      }) => {
        assert(params.athleteId, 400, i18n.t("coaching-portal:dailyAccountabilityActions.specifyAthleteToUpdate"));

        const athleteId = params.athleteId;
        const { athleteSwitch } = query;
        await api(`athlete-daily-accountability`, {
          method: "POST",
          body: { ...body, athleteId },
        }).then((response) => {
          if (athleteSwitch) {
            //athleteSwitch is a param added to the url when the user navigates between profiles using the athletes searcher
            //when its present, the method res.backDontScroll doednt update the locals
            flash("success", i18n.t("coaching-portal:dailyAccountabilityActions.successfullyUpdated"));
            submit(`/actions/refresh`, {
              method: "GET",
              body: { section: "accountability", athlete: athleteId },
            });
          } else {
            flash("success", i18n.t("coaching-portal:dailyAccountabilityActions.successfullyUpdated"));
            res.backDontScroll();
          }
        });
      }
    )
    .post(
      "/daily-accountability/add-athlete-accountability/:athleteId",
      async ({
        req,
        req: { body, params },
        res,
        api,
        flash,
        locals,
        assert,
      }) => {
        assert(params.athleteId, 400, i18n.t("coaching-portal:dailyAccountabilityActions.specifyUserToUpdate"));
        const { query } = locals;
        const { athleteId } = params;
        const { athleteSwitch } = query;
        await api(`athlete-daily-accountability`, {
          method: "POST",
          body: { ...body, athleteId },
        }).then((response) => {
          if (athleteSwitch) {
            flash("success", i18n.t("coaching-portal:dailyAccountabilityActions.successfullyUpdated"));
            submit(`/actions/refresh`, {
              method: "GET",
              body: { section: "accountability", athlete: athleteId },
            });
          } else {
            flash("success", i18n.t("coaching-portal:dailyAccountabilityActions.successfullyUpdated"));
            res.backDontScroll();
          }
        });
      }
    )
    .post(
      "/daily-accountability/remove-accountabilities/:athleteId",
      async ({ req: { body, params }, res, api, flash, locals, assert }) => {
        assert(params.athleteId, 400, i18n.t("coaching-portal:dailyAccountabilityActions.specifyUser"));
        const { query } = locals;
        const { athleteId } = params;
        const { athleteSwitch } = query;
        await api(
          `athlete-daily-accountability?athleteId=${athleteId}&userToRequest=${body.userToRequest}`,
          {
            method: "DELETE",
          }
        ).then((response) => {
          if (athleteSwitch) {
            flash("success", i18n.t("coaching-portal:dailyAccountabilityActions.successfullyUpdated"));
            submit(`/actions/refresh`, {
              method: "GET",
              body: { section: "accountability", athlete: athleteId },
            });
          } else {
            flash("success", i18n.t("coaching-portal:dailyAccountabilityActions.successfullyUpdated"));
            res.backDontScroll();
          }
        });
      }
    );
};

export default DailyAccountability;
